/**
 * Global Color Palette
 * Centralized color management for the entire application
 */

const colors = {
  primary: {
    main: '#4B49AC',
    light: '#7978E9',
    dark: '#3a3882',
    contrastText: '#FFFFFF',
  },

  secondary: {
    main: '#98BDFF',
    light: '#b8d1ff',
    dark: '#7DA0FA',
  },

  // Supporting Colors
  support: {
    lightBlue: '#7DA0FA',
    purple: '#7978E9',
    coral: '#F3797E',
  },

  success: {
    main: '#10B981',
    light: '#34D399',
    dark: '#059669',
  },

  warning: {
    main: '#F59E0B',
    light: '#FBBF24',
    dark: '#D97706',
  },

  error: {
    main: '#F3797E',
    light: '#f69a9e',
    dark: '#f05c62',
  },

  info: {
    main: '#06B6D4',
    light: '#22D3EE',
    dark: '#0891B2',
  },

  background: {
    default: '#F8F9FD',
    paper: '#FFFFFF',
    light: '#FAFBFF',
    dark: '#F1F5F9',
  },

  text: {
    primary: '#1F2937',
    secondary: '#6B7280',
    disabled: '#9CA3AF',
    hint: '#D1D5DB',
  },

  border: {
    main: '#E5E7EB',
    light: '#F3F4F6',
    dark: '#D1D5DB',
  },

  table: {
    headerGradientStart: '#4B49AC',
    headerGradientEnd: '#7978E9',
    headerText: '#FFFFFF',
    rowEven: '#FFFFFF',
    rowOdd: '#F8F9FD',
    rowHover: '#E5E7EB',
    border: '#E5E7EB',
  },

  sidebar: {
    background: '#FFFFFF',
    border: '#E2E8F0',
    text: '#4B5563',
    textActive: '#111827',
    iconDefault: '#64748B',
    iconActive: '#4B49AC',
    selectedBg: '#EEF2FF',
    selectedBgHover: '#E0E7FF',
    selectedBorder: '#4B49AC',
    hover: '#F1F5F9',
    logoBgStart: '#4B49AC',
    logoBgEnd: '#7978E9',
  },

  action: {
    hover: '#F8F9FD',
    selected: '#EEF2FF',
    disabled: '#E5E7EB',
    focus: 'rgba(75, 73, 172, 0.1)',
  },

  overlay: {
    light: 'rgba(0, 0, 0, 0.05)',
    medium: 'rgba(0, 0, 0, 0.1)',
    dark: 'rgba(0, 0, 0, 0.25)',
  },

  chip: {
    default: '#E5E7EB',
    defaultText: '#1F2937',
  },

  // Common Utilities
  white: '#FFFFFF',
  black: '#000000',
  transparent: 'transparent',
};

export default colors;
